var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-video-layer"},[_c('video',{ref:"video",style:(_vm.playerStyle),attrs:{"controls":"","controlsList":"nodownload"}},_vm._l((_vm.sources),function(source,idx){return _c('source',{key:idx,attrs:{"src":source}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }